import _ from "./underscore.js";
export default function chain(obj) {
  var instance = _(obj);
  instance._chain = true;
  return instance;
}
